import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "每隔", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "天要求患者扫描一次", -1)

import { finishTask } from '@/api/home';
import { searchRuleList } from '@/api/setting_rule';
import message from 'ant-design-vue/lib/message';
import { onMounted, reactive } from 'vue'
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 't118',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const formState = reactive({
    trackRuleSize: '',
    trackRuleInterval: '',
});

const data = reactive({
    ruleMonitorId: '',
    options: []
})

onMounted(() => {
    init();
})

const init = () => {
    let option = {
        type: 1,
        page: {
            currPage: 1,
            pageSize: 100,
        },
    };
    searchRuleList(option).then((res: any) => {
        console.log(res.data);
        if (res.data) {
            data.options = res.data
        }
    });
};


const handleChange = (value: any) => {
    console.log(value,data.ruleMonitorId);
    data.ruleMonitorId = value.option.id
    formState.trackRuleSize = value.option.size
    formState.trackRuleInterval = value.option.intervalTime
}

const onSubmit = () => {
    let processDefinitionId = route.query.processDefinitionId;
    let processInstanceId = route.query.processInstanceId;
    let processDefinitionKey = route.query.processDefinitionKey;
    let runTimeTaskId = route.query.runTimeTaskId;
    let taskCode = route.query.taskCode
    let parameters = {
        processDefinitionId,
        processInstanceId,
        processDefinitionKey,
        runTimeTaskId,
        taskCode,
        params: {
            patientId: route.query.patientId,
            trackRuleSize: formState.trackRuleSize,
            trackRuleInterval: formState.trackRuleInterval,
            ruleMonitorId:data.ruleMonitorId
        }
    }
    finishTask(parameters).then(() => {
        message.success("操作成功");
        router.push({
            path: "/home",
        });
    });
}


return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, {
      layout: "horizontal",
      model: formState,
      style: {"width":"40%","text-align":"left"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "选择规则" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: data.ruleMonitorId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.ruleMonitorId) = $event)),
              "label-in-value": "",
              options: data.options,
              "field-names": { label: 'name', value: 'id', options: 'children' },
              onChange: handleChange
            }, null, 8, ["value", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "间隔时间" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_a_input_number, {
                  value: formState.trackRuleInterval,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.trackRuleInterval) = $event))
                }, null, 8, ["value"]),
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "扫描次数" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: formState.trackRuleSize,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.trackRuleSize) = $event)),
              placeholder: "扫描次数"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 4 } }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})